import React from 'react'

export default function HorizontalRule({ height, borderType, colorBorder }) {
    return (
        <>
            <div style={{ width: '100%', height: height, borderBottom: `1px ${borderType} #777777` }} />
        </>
    )
}
